/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentScheduleRequestBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AiAgentScheduleRequestBase.fixupPrototype; }

    static newInstance(model: Partial<AiAgentScheduleRequestBase>): AiAgentScheduleRequestBase {
        let obj = Object.assign(new AiAgentScheduleRequestBase(), model);
        AiAgentScheduleRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentScheduleRequestBase>): AiAgentScheduleRequestBase {
        if (!model) return null;
        return AiAgentScheduleRequestBase.newInstance(<AiAgentScheduleRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentScheduleRequestBase) {
        if (!obj) return;

        models.AiAgentScheduleRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentScheduleRequestBase): boolean {
        switch (obj.__type)
        {
            case "AiAgentScheduleRequest":
                Object.setPrototypeOf(obj, models.AiAgentScheduleRequest.prototype);
                break;
            case "AssessmentAgentScheduleRequest":
                Object.setPrototypeOf(obj, models.AssessmentAgentScheduleRequest.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AiAgentScheduleRequestBase)[] {
        return [
            models.AiAgentScheduleRequest,
            models.AssessmentAgentScheduleRequest,
        ];
    }

    fixupFields() {
    }

}
